import { Divider, SxProps } from '@mui/material';

export const NavSeparator = (p: { className?: string; sx?: SxProps }) => (
  <Divider sx={[{ borderColor: '#4b5157' }, p.sx ?? {}] as SxProps} />
);
